import { useAuth } from "@/lib/auth";
import { PRO_PRODUCT_ID } from "@/lib/stripe-constants";

export const TRIAL_DAYS = 7;

/**
 * Nombre de jours restants d'essai (1..7) ou null si pas/plus en essai.
 * L'essai = compte non abonné, inscrit depuis moins de TRIAL_DAYS jours.
 */
export function getTrialDaysLeft(createdAt?: string | null): number | null {
  if (!createdAt) return null;
  const daysSince = (Date.now() - new Date(createdAt).getTime()) / (1000 * 60 * 60 * 24);
  if (daysSince >= TRIAL_DAYS) return null;
  return Math.max(1, Math.ceil(TRIAL_DAYS - daysSince));
}

export function useSubscription() {
  const { subscription, subscriptionLoading, user } = useAuth();

  const isSubscribed = subscription.subscribed;

  // Essai Pro : pas d'abonnement Stripe + inscrit depuis moins de 7 jours.
  const trialDaysLeft = isSubscribed ? null : getTrialDaysLeft(user?.created_at);
  const isTrialActive = trialDaysLeft !== null;

  const isPaidPro = isSubscribed && subscription.product_id === PRO_PRODUCT_ID;
  // Pendant l'essai, l'utilisateur a accès à TOUTES les fonctionnalités Pro.
  const isPro = isPaidPro || isTrialActive;
  const isStarter = isSubscribed && !isPaidPro;

  return {
    isSubscribed,
    isPro,
    isPaidPro,
    isStarter,
    isTrialActive,
    trialDaysLeft,
    subscription,
    loading: subscriptionLoading,
  };
}
